import React, {Component} from 'react';
import { Redirect } from 'react-router-dom';
import { Container, Row, Col, Tab, Nav, Form, Button, Alert, Spinner } from "react-bootstrap";
import { FaArrowLeft, FaSave, FaRegTrashAlt } from 'react-icons/fa';

import Side from "./Sidebar";
import Top from "./Topbar";
import Crypt from '../lib/Crypt';
import C from '../lib/Config';
import swal from 'sweetalert';
import ChemoMedicinePopup from "./ChemoMedicinePopup";
import ProtocolDosagePopup from "./ProtocolDosagePopup";
import PreConditionMSTPopup from "./PreConditionMSTPopup";
import ReduceDosagePopup from "./ReduceDosagePopup";
import AdverseEffectDisPopup from "./AdverseEffectDisPopup";
import AdverseEffectTerPopup from "./AdverseEffectTerPopup";
import PrimarySitePicker from "./PrimarySitePicker";
import { fetchPrimarySiteOptions, readPrimarySites, buildPrimarySitesPayload, setLeadSite, syncSelection } from '../lib/PrimarySiteUtils';

const protocolTypeArr = [
    { key: Crypt.getUniqueKey('0'), id: '1', label: 'IV' },
    { key: Crypt.getUniqueKey('1'), id: '2', label: 'Oral' }, 
]
const fnRiskArr = [
    { key: Crypt.getUniqueKey('0'), id: 'H', label: 'High (FN Risk 20% or more)' },
    { key: Crypt.getUniqueKey('1'), id: 'I', label: 'Intermediate (FN Risk 10 - 19%)' },
    { key: Crypt.getUniqueKey('2'), id: 'L', label: 'Low (FN Risk < 10%)' }, 
]
const AntiemeticRiskList = [
    { key: Crypt.getUniqueKey('0'), id: '0', label: '- Select Antiemetic Risk -' },
    { key: Crypt.getUniqueKey('3'), id: '3', label: 'Low' },
    { key: Crypt.getUniqueKey('2'), id: '2', label: 'Moderate' },
    { key: Crypt.getUniqueKey('4'), id: '4', label: 'Minimal' },
    { key: Crypt.getUniqueKey('1'), id: '1', label: 'High' },
]

export default class ViewProtocol extends Component {
    constructor(props) {
        super(props);
        this.protocolDosageChild = React.createRef();
        this.reduceDosageChild = React.createRef();
        this.adverseEffectChild = React.createRef();
        this.state = {
            show: false,
            close: false,
            protocolId:'',
            protocolName:'',
            scheduleName:'',
            scheduleDosage: '',
            antiemeticRiskLvlId: '',
            antiemeticRisk:'',
            instructNurse:'',
            instructPatient:'',
            nextVisit:'',
            drugInteractions:'',
            futureTestsInstructions:'',
            riskDeath:'',
            reference:'',
            adverseEvent : '',
            chemoDoseage: '',
            isProtocolEditable: 'Y',
            instructStockist: '',
            redirectProtocolMaster: false,
            fnRiskArr: [],
            protocolTypeArr: [],
            chemoMedicineList: [],
            reduceDosageList: [],
            preConditionMSTList: [],
            protocolDosageList: [],
            advEffDiscontinueList: [],
            advEffTerminateList: [],
            chemoDoseageList: [],
            scheduleMstArr: [],
            protocol: [],
            schedule: '',
            scheduleDosageName: '',
            isHospitalAdmin: false,
            userInstituteIds: [],
            protocolInstituteId: null,
            multiDayCycle: false, treatmentDays: '', primarySiteArr: [],
            // The protocol's own sites, and whether the server actually told us
            // what they are. `primarySitesLoaded` gates the `primarySites` key in
            // the save body: while it is false the key is OMITTED, so a save that
            // happens before/without a successful load leaves the links untouched
            // instead of deleting them. Never initialise it to true, and never
            // send `primarySites` without consulting it. See lib/PrimarySiteUtils.js.
            primarySites: [], primarySitesLoaded: false,
       };
       this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount () {
        const userRole = localStorage.getItem('userRoleDto');
        if (userRole) {
            const parsedRole = JSON.parse(userRole);
            if (parsedRole.roleName === 'Hospital Admin') {
                this.setState({ isHospitalAdmin: true });
                this.getUserInstituteIds();
            }
        }
        if(this.props.location && this.props.location.search){
            let protocolId = this.props.location.search.slice(3);
            if(protocolId){
                this.getProtocolDetail(protocolId);
            }else{
                console.log(" No protocol data ")
            }
        }
        this.fetchPrimarySites();
    }

    getUserInstituteIds = () => {
        const userId = localStorage.getItem('userId');
        return fetch(`${C.getUrl()}/institute/getAllInstituteByUserId/${userId}`)
            .then(res => res.json())
            .then(res => {
                const data = Array.isArray(res) ? res : (res.message ? JSON.parse(res.message) : []);
                const ids = data.map(d => d.instituteId);
                this.setState({ userInstituteIds: ids });
            })
            .catch(err => console.error("Error fetching user institutes: " + err));
    }

    getProtocolDetail(protocolId){
        return fetch(C.getUrl() + '/protocol/getProtocolDetails/'+protocolId)
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            this.setProtocolDetail(JSON.parse(resObj.message));
        })
        .catch(err => {
            console.log("Error : " + err);
        });
    }

    setProtocolDetail(protolObj){
        this.setState({protocolId : protolObj.protocolId});
        this.setState({protocolName : protolObj.protocolName});
        this.setState({protocolInstituteId : protolObj.instituteId ?? null});
        this.setState({scheduleName: protolObj.scheduleMstDTO.scheduleName});
        this.setState({scheduleDosageName: protolObj.dosageFrequency.scheduleName});
        this.setState({antiemeticRiskLvlId: protolObj.antiemeticRiskLvlId});
        this.setState({protocolType: protolObj.chemoTypeId});
        this.setState({antiemeticRisk : protolObj.antiemeticRisk});
        this.setState({instructNurse : protolObj.nurseInstructions});
        this.setState({instructPatient : protolObj.patientInstructions});
        this.setState({nextVisit : protolObj.nextVisitInstructions});
        this.setState({drugInteractions : protolObj.drugInteractions});
        this.setState({futureTestsInstructions : protolObj.futureTestsInstructions});
        this.setState({riskDeath : protolObj.deathRisk});
        this.setState({reference : protolObj.reference});
        this.setState({fnRisk : protolObj.fnRisk});
        this.setState({postChemoMedic : protolObj.postChemoMed});
        this.setState({premedications : protolObj.premedications});
        this.setState({gcsfProphylaxis : protolObj.gCSFProphylaxis});
        this.setState({modificationEvent : protolObj.doseModAdverseEvents});
        this.setState({modificationCBC : protolObj.doseModCBC});
        this.setState({modificationLFT : protolObj.doseModLFT});
        this.setState({modificationRFT : protolObj.doseModRFT});
        this.setState({antiProphylaxis : protolObj.antithromboProphylaxis});
        this.setState({chemoDoseage : protolObj.chemoDoseageMethod});
        this.setState({instructStockist : protolObj.antiallergicMedications});
        this.setState({adverseEvent : protolObj.adverseEvents});
        this.setState({isProtocolEditable : protolObj.isProtocolEditable});
        // Deliberately NOT reading the deprecated scalar `protolObj.primarySite`
        // — it is now just a mirror of the lead site's name and is ignored on write.
        const loadedSites = readPrimarySites(protolObj);
        if (loadedSites !== null) {
            this.setState({ primarySites: loadedSites, primarySitesLoaded: true });
        }
        this.setState({multiDayCycle : protolObj.multiDayCycle || false});
        this.setState({treatmentDays : protolObj.treatmentDays || ''});
        this.getAllSchedule();
        this.setState({schedule: protolObj.scheduleMstDTO.scheduleId});
        this.setState({scheduleDosage: protolObj.dosageFrequency.scheduleId});
        this.getChemoMedDetails();
    }

    fetchPrimarySites = () => {
        return fetchPrimarySiteOptions()
            .then(data => {
                this.setState({ primarySiteArr: data });
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error fetching primary sites: " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    handlePrimarySitesChange = (selectedIds) => {
        this.setState(prevState => ({
            primarySites: syncSelection(prevState.primarySites, selectedIds, prevState.primarySiteArr)
        }));
    }

    handleLeadSiteChange = (siteId) => {
        this.setState(prevState => ({
            primarySites: setLeadSite(prevState.primarySites, siteId)
        }));
    }

    getAllSchedule = async () => {
        fetch(C.getUrl() + '/schedule/getAllSchedule')
            .then(res => res.json())
            .then(res => {
                let data = JSON.parse(res.message);
                var arr = [];
                data.map((item, index) => {
                    let jsonList = new Object();
                    jsonList['key'] = Crypt.getUniqueKey(index);
                    jsonList['id'] = item.selectionId;
                    jsonList['label'] = item.selectionValue;
                    jsonList['scheduleDays'] = item.additionalValue;
                    arr.push(jsonList);
                });
                this.setState({ scheduleMstArr: arr });
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    handleChange(event){
        if(event.target.name === 'protocolTitle'){
            this.setState({protocolTitle: event.target.value});
        }
        if(event.target.name === 'schedule'){
            this.setState({schedule: event.target.value});
        }
        if(event.target.name === 'scheduleDosage'){
            this.setState({scheduleDosage: event.target.value});
        }
        if(event.target.name === 'protocolType'){
            this.setState({protocolType: event.target.value});
        }
        if(event.target.name === 'antiemeticRisk'){
            this.setState({antiemeticRiskLvlId: event.target.value});
        }
        if(event.target.name === 'fnRisk'){
            //let myNumber = (event.target.value) ? parseFloat(event.target.value) : 0;
            this.setState({fnRisk: event.target.value});
        }
        if(event.target.name === 'chemoDoseage'){
            this.setState({chemoDoseage: event.target.value});
        }
        if(event.target.name === 'instructNurse'){
            this.setState({instructNurse: event.target.value});
        }
        if(event.target.name === 'instructPatient'){
            this.setState({instructPatient: event.target.value});
        }
        if(event.target.name === 'instructStockist'){
            this.setState({instructStockist: event.target.value});
        }
        if(event.target.name === 'nextVisit'){
            this.setState({nextVisit: event.target.value});
        }
        if(event.target.name === 'drugInteractions'){
            this.setState({drugInteractions: event.target.value});
        }
        if(event.target.name === 'adverseEvent'){
            this.setState({adverseEvent: event.target.value});
        }
        if(event.target.name === 'riskDeath'){
            this.setState({riskDeath: event.target.value});
        }
        if(event.target.name === 'reference'){
            this.setState({reference: event.target.value});
        }
        if (event.target.name === 'schedule') {
            this.setState({ schedule: event.target.value });
        }
        if(event.target.name === 'multiDayCycle'){
            this.setState({multiDayCycle: event.target.checked, treatmentDays: ''});
        }
        if(event.target.name === 'treatmentDays'){
            this.setState({treatmentDays: event.target.value});
        }
    }

    validateProtocol(){
        let formIsValid = true;
        let errors = {};
        if (this.state.protocolTitle === "" || this.state.protocolTitle === null) {
            errors["protocolTitle"] = "Please enter first name";
            formIsValid = false;
        }
        if (this.state.schedule === "" || this.state.schedule === null) {
            errors["schedule"] = "Please select schedule for doctor visit";
            formIsValid = false;
        }
        if (this.state.protocolType === "" || this.state.protocolType === null) {
            errors["protocolType"] = "Please select schedule for doctor visit";
            formIsValid = false;
        }
        if (this.state.scheduleDosage === "" || this.state.scheduleDosage === null) {
            errors["scheduleDosage"] = "Please select schedule for dosage";
            formIsValid = false;
        }
        if (this.state.antiemeticRisk === "" || this.state.antiemeticRisk === null) {
            errors["antiemeticRisk"] = "Please enter antiemetic risk";
            formIsValid = false;
        }
        if (this.state.fnRisk === "" || this.state.fnRisk === null) {
            errors["fnRisk"] = "Please enter Fn risk";
            formIsValid = false;
        }
        if (this.state.chemoDoseage === "" || this.state.chemoDoseage === null) {
            errors["chemoDoseage"] = "Please enter chemo doseage method";
            formIsValid = false;
        }
        if (this.state.instructNurse === "" || this.state.instructNurse === null) {
            errors["instructNurse"] = "Please enter special instruction to nurse";
            formIsValid = false;
        }
        if (this.state.instructPatient === "" || this.state.instructPatient === null) {
            errors["instructPatient"] = "Please enter special instruction to patients";
            formIsValid = false;
        }
        if (this.state.instructStockist === "" || this.state.instructStockist === null) {
            errors["instructStockist"] = "Please enter stockist instruction";
            formIsValid = false;
        }
        if (this.state.nextVisit === "" || this.state.nextVisit === null) {
            errors["nextVisit"] = "Please enter next visit instructions";
            formIsValid = false;
        }
        if (this.state.drugInteractions === "" || this.state.drugInteractions === null) {
            errors["drugInteractions"] = "Please enter drug interactions";
            formIsValid = false;
        }
        if (this.state.adverseEvent === "" || this.state.adverseEvent === null) {
            errors["adverseEvent"] = "Please enter adverse events";
            formIsValid = false;
        }
        if (this.state.riskDeath === "" || this.state.riskDeath === null) {
            errors["riskDeath"] = "Please enter risk of death";
            formIsValid = false;
        }
        if (this.state.reference === "" || this.state.reference === null) {
            errors["reference"] = "Please enter reference";
            formIsValid = false;
        }
        const treatmentDaysPattern = /^[1-9]\d*(-[1-9]\d*)?(,[1-9]\d*(-[1-9]\d*)?)*$/;
        if (this.state.multiDayCycle) {
            if (!this.state.treatmentDays || this.state.treatmentDays.trim() === '') {
                errors["treatmentDays"] = "Please enter treatment days (e.g. 1-5 or 1,7,15)";
                formIsValid = false;
            } else if (!treatmentDaysPattern.test(this.state.treatmentDays.trim())) {
                errors["treatmentDays"] = "Invalid format. Use ranges (e.g. 1-5), comma-separated days (e.g. 1,7,15), or a combination (e.g. 1-3,6-8). All day numbers must be greater than 0.";
                formIsValid = false;
            }
        }
        this.setState({protocol: errors });
        return formIsValid;
    }

    saveProtocol(event){
        let isThisValidForm = false;
        if (this.validateProtocol()) { 
            isThisValidForm = true;
            let data = {
                protocolId: this.state.protocolId,
                scheduleMstDTO: {
                    scheduleId: this.state.schedule
                },
                dosageFrequency: {
                    scheduleId: this.state.scheduleDosage
                },
                updatedByIdUser: {
                    userId: localStorage.getItem('userId')
                },
                chemoTypeId  : this.state.protocolType,
                protocolDesc  : this.state.protocolName,
                protocolName  : this.state.protocolName,
                antiemeticRiskLvlId  : this.state.antiemeticRiskLvlId,
                fnRisk  : this.state.fnRisk,
                nurseInstructions  : this.state.instructNurse,
                patientInstructions  : this.state.instructPatient,
                nextVisitInstructions  : this.state.nextVisit,
                drugInteractions  : this.state.drugInteractions,
                antiallergicMedications  : this.state.instructStockist,
                chemoTreatment  : this.state.chemoDoseage,
                chemoDoseageMethod  : this.state.chemoDoseage,
                deathRisk  : this.state.riskDeath,
                reference  : this.state.reference,
                adverseEvents : this.state.adverseEvent,
                multiDayCycle: this.state.multiDayCycle,
                treatmentDays: this.state.multiDayCycle ? this.state.treatmentDays : null,
                // Only sent once we know what the server currently has. Omitting the
                // key leaves the links untouched; sending [] DELETES them all, so an
                // empty array here must mean "the user cleared every site", never
                // "the form had not loaded yet". The deprecated `primarySite` string
                // is not sent at all — the backend ignores it.
                ...(this.state.primarySitesLoaded && {
                    primarySites: buildPrimarySitesPayload(this.state.primarySites)
                }),
            }
            //console.log(JSON.stringify(data));
            return fetch(C.getUrl() + '/protocol/saveUpdate', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                // Primary-site failures come back as HTTP 404 carrying statusCode 400
                // (an odd pre-existing mapping in this controller). fetch() does not
                // reject on 404, and these bodies have no `subErrors`, so without this
                // branch the check below would report "Error : undefined". The useful
                // text is in `debugMessage` — `message` is always "Unexpected error".
                if (obj.statusCode !== undefined && obj.statusCode !== 200) {
                    const detail = process.env.NODE_ENV !== 'production' && obj.debugMessage
                        ? obj.debugMessage
                        : (obj.message || "Could not update the protocol. Please retry.");
                    swal({ title: "Warning!", text: detail, icon: "error", buttons: false, timer: 4000, });
                    return;
                }
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 3000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
                    let objmsg = JSON.parse(obj.message);
                    if(objmsg!=null&&objmsg.protocolId!=0){
                        console.log("Protocol Save Res Inside IF");
                        this.setState({ protocolId: objmsg.protocolId })
                    }
                    // Re-sync from what the server actually stored, so the picker
                    // reflects the normalised link set (and the lead it settled on).
                    const savedSites = readPrimarySites(objmsg);
                    if (savedSites !== null) {
                        this.setState({ primarySites: savedSites, primarySitesLoaded: true });
                    }
                    swal({ title: "Protocol updated successfully", icon: "success", buttons: false, timer: 3000, });
                    setTimeout(() => { this.setState({ key: 'second'}) }, 4000)
                }
            })
            .catch(err => {
                 swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 3000, });
            });
        }
    }

    /* Chemo Med Changes Start */
    getChemoMedDetails() {
        if(this.state.chemoMedicineList === undefined || this.state.chemoMedicineList.length == 0){
            return fetch(C.getUrl() + '/chemoMedicine/getChemoMedDetails/'+this.state.protocolId)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let resJson = JSON.parse(resObj.message);
                var arr = [];
                resJson.map(function (d) {
                    arr.push({ chemoInstructions: d.chemoInstructions, chemoMedicineName: d.chemoMedicineName, chemoMedicineId: d.chemoMedicineId });
                });
                this.setState({ chemoMedicineList: arr });
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }

    setChemoMedicineHandler = (chemoMedicineData) => { 
        var chemoMedicineDataTemp= this.state.chemoMedicineList;
        chemoMedicineDataTemp.push(chemoMedicineData);
        this.setState({ chemoMedicineList: chemoMedicineDataTemp }); 
        this.setState({ showChemoMedicinePopup: false });
    }

    closeChemoMedicinePopup = () => {
        this.setState({ showChemoMedicinePopup: false });
    }

    showChemoMedicinePopup = () => {
        this.setState({ showChemoMedicinePopup: true });
    }

    deleteChemo = (chemoMedicineId, chemoMedicine) => {
        console.log("chemoMedicineId : "+chemoMedicineId);
        if(chemoMedicineId === 0 || chemoMedicineId === ''){
            //console.log("chemoMedicine : "+chemoMedicine);
            let arr = this.state.chemoMedicineList;
            const requiredIndex = arr.findIndex(el => {
                return el.medicineId === chemoMedicine;
            });
            //console.log("requiredIndex : "+requiredIndex);
            if(requiredIndex === -1){
                return false;
            };
    
            arr.splice(requiredIndex, 1);
            //console.log("tempArr : "+JSON.stringify(arr));
            this.setState({ chemoMedicineList : arr });
        }else{
            swal({
                title: 'Are you sure?',
                text: "Once deleted you will not be able to recover this.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: "Yes",
                closeOnConfirm: false,
                buttons:true,
                buttons: ["No", "Yes"]
            }).then((isConfirm) => {
                if (isConfirm) {
                    return fetch(C.getUrl() + '/chemoMedicine/deleteChemoMedicine/'+chemoMedicineId)
                    .then(res => res.json())
                    .then(res => {
                        let resObj = res;
                        console.log(JSON.stringify(resObj));
                        swal({ title: resObj.message, icon: "success", buttons: false, timer: 2000, });
                        
                        let arr = this.state.chemoMedicineList;
                        const requiredIndex = arr.findIndex(el => {
                            return el.chemoMedicineId === chemoMedicineId;
                        });
                        console.log("requiredIndex : "+requiredIndex);
                        if(requiredIndex === -1){
                            return false;
                        };
                
                        arr.splice(requiredIndex, 1);
                        //console.log("tempArr : "+JSON.stringify(arr));
                        this.setState({ chemoMedicineList : arr });
                    })
                    .catch(err => {
                        console.log("Error : " + err);
                    });
                }
            });
        }
    }

    saveChemo(event){
        var chemoMedicineDTOList = [];
        var tempProtocolId = this.state.protocolId;
        console.log("before save chemoMedicineList : "+JSON.stringify(this.state.chemoMedicineList));
        this.state.chemoMedicineList.forEach(function (obj) {
            if(obj.chemoMedicineId == 0 || obj.chemoMedicineId == ''){
                let data = {
                    chemoMedicineId: obj.chemoMedicineId,
                    activeInd: 'Y',
                    chemoInstructions: obj.chemoInstructions,
                    createdDt: new Date(),
                    updatedDt: new Date(),
                    createdByIdUser: {
                        userId: localStorage.getItem('userId')
                    },
                    updatedByIdUser: {
                        userId: localStorage.getItem('userId')
                    }, 
                    medicineMstDto: {
                        medicineId: obj.medicineId,
                        medicineName: obj.chemoMedicineName
                    }, 
                    protocolMstDTO: {
                        protocolId: tempProtocolId
                    }
                }
                chemoMedicineDTOList.push(data);
            }
        });
        console.log("before save : "+JSON.stringify(chemoMedicineDTOList));
        if(chemoMedicineDTOList.length !== 0){
            return fetch(C.getUrl() + '/chemoMedicine/saveChemoMedicine', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(chemoMedicineDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    //alert(error);
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => {
                        this.setState({ saveLoader: false })
                    }, 3000)
                    let objmsg = JSON.parse(obj.message);

                    let tmpArr = this.state.chemoMedicineList;
                    console.log("Before addition : "+JSON.stringify(tmpArr));

                    objmsg.map(function (d) {
                        tmpArr.push({ chemoInstructions: d.chemoInstructions, chemoMedicineName: d.medicineMstDto.medicineName, chemoMedicineId: d.chemoMedicineId });
                    });
                    let result = tmpArr.filter(
                    (thing, index, self) =>
                        index ===
                        self.findIndex((t) => t.chemoMedicineName === thing.chemoMedicineName && t.chemoMedicineId !== 0)
                    );
                    console.log("After updation result : "+JSON.stringify(result));
                    this.setState({chemoMedicineList: result });
                    swal({ title: "Chemo medicine saved successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'third'}) }, 2000)
                }
            })
            .catch(err => {
                    swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 20000, });
            });
        }
    }
    /* Chemo Med Changes End */

    /* Protocol Dosage Changes Start */
    getProtocolDosageDetails() {
        if(this.state.protocolDosageList === undefined || this.state.protocolDosageList.length == 0){
            return fetch(C.getUrl() + '/chemoMedicine/getProtocolDosageDetails/'+this.state.protocolId)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let resJson = JSON.parse(resObj.message);
                var arr = [];
                resJson.map(function (d) {
                    arr.push({ chemoMedicineDosageValue: d.chemoMedicineName, 
                        dosageValues: d.dosageValues,
                        dosageQtys: d.dosageQtys,
                        dosageUnitValues: d.dosageUnitValues,
                        chemoMedicineDId: d.chemoMedicineDId});
                });
                this.setState({ protocolDosageList: arr });
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }

    closeProtocolDosagePopup = () => {
        this.setState({ showProtocolDosagePopup: false });
    }

    showProtocolDosagePopup = () => {
        this.setState({ showProtocolDosagePopup: true });
        this.protocolDosageChild.current.getProtocolDosageDetail(this.state.chemoMedicineList);
        
    }

    setProtocolDosageHandler = (protocolDosageData) => { 
        var protocolDosageDataTemp= this.state.protocolDosageList;
        protocolDosageDataTemp.push(protocolDosageData);
        this.setState({ protocolDosageList: protocolDosageDataTemp }); 
        this.setState({ showProtocolDosagePopup: false });
    }

    deleteProtocolDosage = (chemoMedicineDId, chemoMedicineDosageID, dosageValues, dosageQtys) => {
        console.log("chemoMedicineDId : "+chemoMedicineDId);
        if(chemoMedicineDId === 0 || chemoMedicineDId === ''){
            let arr = this.state.protocolDosageList;
            const requiredIndex = arr.findIndex(el => {
                if(el.chemoMedicineDosageID === chemoMedicineDosageID && el.dosageValues === dosageValues && el.dosageQtys === dosageQtys){
                    return el.chemoMedicineDosageID === chemoMedicineDosageID;
                }
            });
            //console.log("requiredIndex : "+requiredIndex);
            if(requiredIndex === -1){
                return false;
            };
    
            arr.splice(requiredIndex, 1);
            //console.log("tempArr : "+JSON.stringify(arr));
            this.setState({ protocolDosageList : arr });
        }else{
            swal({
                title: 'Are you sure?',
                text: "Once deleted you will not be able to recover this.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: "Yes",
                closeOnConfirm: false,
                buttons:true,
                buttons: ["No", "Yes"]
            }).then((isConfirm) => {
                if (isConfirm) {
                    return fetch(C.getUrl() + '/chemoMedicine/deleteChemoMedicineDosage/'+chemoMedicineDId)
                    .then(res => res.json())
                    .then(res => {
                        let resObj = res;
                        console.log(JSON.stringify(resObj));
                        swal({ title: resObj.message, icon: "success", buttons: false, timer: 2000, });
                        
                        let arr = this.state.protocolDosageList;
                        const requiredIndex = arr.findIndex(el => {
                            return el.chemoMedicineDId === chemoMedicineDId;
                        });
                        //console.log("requiredIndex : "+requiredIndex);
                        if(requiredIndex === -1){
                            return false;
                        };
    
                        arr.splice(requiredIndex, 1);
                        //console.log("tempArr : "+JSON.stringify(arr));
                        this.setState({ protocolDosageList : arr });
                    })
                    .catch(err => {
                        console.log("Error : " + err);
                    });
                }
            });
        }
    }

    saveProtocolDosage(event){
        var chemoMedicineDosageDTOList = [];
        this.state.protocolDosageList.forEach(function (obj) {
            if(obj.chemoMedicineDId === 0 || obj.chemoMedicineDId === ''){
                let data = {
                    chemoMedicineDId: obj.chemoMedicineDId,
                    activeInd: 'Y',
                    chemoInstructions: obj.chemoInstructions,
                    createdDt: new Date(),
                    updatedDt: new Date(),
                    level: obj.dosageLevels,
                    quantity: obj.dosageQtys,
                    unitMstDto: {
                        unitId: obj.dosageUnits,
                        unitName: obj.dosageUnitValues
                    },
                    updatedByIdUser: {
                        userId: localStorage.getItem('userId')
                    },
                    createdByIdUser: {
                        userId: localStorage.getItem('userId')
                    },
                    chemoMedicineDTO: {
                        chemoMedicineId: obj.chemoMedicineDosageID,
                        medicineMstDto: {
                            medicineName: obj.chemoMedicineDosageValue
                        }
                    }
                }
                chemoMedicineDosageDTOList.push(data);
            }
        });
        if(chemoMedicineDosageDTOList.length !== 0){
            return fetch(C.getUrl() + '/chemoMedicine/saveChemoMedicineDosage', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(chemoMedicineDosageDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
                    let objmsg = JSON.parse(obj.message);
                    
                    let tmpArr = this.state.protocolDosageList;
                    console.log("Before addition : "+JSON.stringify(tmpArr));

                    objmsg.map(function (d) {
                        tmpArr.push({ chemoMedicineDosageValue: d.chemoMedicineDTO.medicineMstDto.medicineName, 
                            dosageValues: d.level,
                            dosageQtys: d.quantity,
                            dosageUnitValues: d.unitMstDto.unitName,
                            chemoMedicineDId: d.chemoMedicineDId });
                    });
                    console.log("After Addition : "+JSON.stringify(tmpArr));
                    let result = tmpArr.filter(
                    (thing, index, self) =>
                        index ===
                        self.findIndex((t) => t.chemoMedicineDosageValue === thing.chemoMedicineDosageValue
                        && t.dosageValues === thing.dosageValues
                        && t.chemoMedicineDId !== 0)
                    );
                    console.log("After updation result : "+JSON.stringify(result));
                    this.setState({protocolDosageList: result });

                    swal({ title: "Protocol dosage saved successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'fourth'}) }, 4000)
                }
            })
            .catch(err => {
                    swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
        }
    }
    /* Protocol Dosage Changes End */

    /* Protocol Precondition Changes Start */

    getProtocolPreCondition() {
        if(this.state.preConditionMSTList === undefined || this.state.preConditionMSTList.length == 0){
            return fetch(C.getUrl() + '/protocol/getProtocolPreCondition/'+this.state.protocolId)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let resJson = JSON.parse(resObj.message);
                var arr = [];
                resJson.map(function (d) {
                    arr.push({ reportParamsNames: d.reportParamsNames, 
                        preConditionListsNames: d.compValue,
                        preConditionValues: d.preConditionValues,
                        protocolpreconditionsId: d.protocolpreconditionsId });
                });
                this.setState({ preConditionMSTList: arr });
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }

    setPreConditionMSTHandler = (preConditionMSTData) => { 
        var preConditionMSTDataTemp= this.state.preConditionMSTList;
        preConditionMSTDataTemp.push(preConditionMSTData);
        this.setState({ preConditionMSTList: preConditionMSTDataTemp }); 
        this.setState({ showPreConditionMSTPopup: false });
    }

    closePreConditionMSTPopup = () => {
        this.setState({ showPreConditionMSTPopup: false });
    }

    showPreConditionMSTPopup = () => {
        this.setState({ showPreConditionMSTPopup: true });
    }

    deletePrecondition = (protocolpreconditionsId, reportParamsID, preConditionValues) => {
        //console.log("reportParamsID : "+reportParamsID);
        if(protocolpreconditionsId === 0 || protocolpreconditionsId === ''){
            let arr = this.state.preConditionMSTList;
            const requiredIndex = arr.findIndex(el => {
                if(el.reportParamsID === reportParamsID && el.preConditionValues === preConditionValues){
                    return el.reportParamsID === reportParamsID;
                }
            });
            //console.log("requiredIndex : "+requiredIndex);
            if(requiredIndex === -1){
                return false;
            };

            arr.splice(requiredIndex, 1);
            //console.log("tempArr : "+JSON.stringify(arr));
            this.setState({ preConditionMSTList : arr });
        }else{
            swal({
                title: 'Are you sure?',
                text: "Once deleted you will not be able to recover this.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: "Yes",
                closeOnConfirm: false,
                buttons:true,
                buttons: ["No", "Yes"]
            }).then((isConfirm) => {
                if (isConfirm) {
                    return fetch(C.getUrl() + '/protocol/deleteProtocolPreCondition/'+protocolpreconditionsId)
                    .then(res => res.json())
                    .then(res => {
                        let resObj = res;
                        console.log(JSON.stringify(resObj));
                        swal({ title: resObj.message, icon: "success", buttons: false, timer: 2000, });
                        
                        let arr = this.state.preConditionMSTList;
                        const requiredIndex = arr.findIndex(el => {
                            return el.protocolpreconditionsId === protocolpreconditionsId;
                        });
                        //console.log("requiredIndex : "+requiredIndex);
                        if(requiredIndex === -1){
                            return false;
                        };

                        arr.splice(requiredIndex, 1);
                        //console.log("tempArr : "+JSON.stringify(arr));
                        this.setState({ preConditionMSTList : arr });
                    })
                    .catch(err => {
                        console.log("Error : " + err);
                    });
                }
            });
        }
    }

    savePreConditionMST(event){
        var protocolPreconditionDTOList = [];
        var trmpProtocolId = this.state.protocolId;
        this.state.preConditionMSTList.forEach(function (obj) {
            if(obj.protocolpreconditionsId == 0 || obj.protocolpreconditionsId == ''){
                let data = {
                    protocolpreconditionsId: obj.protocolpreconditionsId,
                    activeInd: 'Y',
                    operator: obj.preConditionListsID,
                    value: obj.preConditionValues,
                    createdDt: new Date(),
                    updatedDt: new Date(),
                    createdByIdUser: {
                        userId: localStorage.getItem('userId')
                    },
                    updatedByIdUser: {
                        userId: localStorage.getItem('userId')
                    }, 
                    reportParameterMstDTO: {
                        reportParamId: obj.reportParamsID,
                        reportParamName: obj.reportParamsNames
                    }, 
                    protocolMstDTO: {
                        protocolId: trmpProtocolId
                    }
                }
                protocolPreconditionDTOList.push(data);
            }
        });
        if(protocolPreconditionDTOList.length !== 0){
            return fetch(C.getUrl() + '/protocol/saveProtocolPreCondition', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(protocolPreconditionDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => {this.setState({ saveLoader: false })}, 3000)
                    let objmsg = JSON.parse(obj.message);

                    let tmpArr = this.state.preConditionMSTList;
                    console.log("Before addition : "+JSON.stringify(tmpArr));

                    objmsg.map(function (d) {
                        tmpArr.push({ reportParamsNames: d.reportParameterMstDTO.reportParamName,
                            preConditionListsNames: d.operator === 'GE' ? 'Greater Than' : 'Less Than',
                            preConditionValues: d.value,
                            protocolpreconditionsId: d.protocolpreconditionsId });
                    });
                    console.log("After Addition : "+JSON.stringify(tmpArr));
                    let result = tmpArr.filter(
                    (thing, index, self) =>
                        index ===
                        self.findIndex((t) => t.reportParamsNames === thing.reportParamsNames
                        && t.preConditionValues === thing.preConditionValues
                        && t.protocolpreconditionsId !== 0)
                    );
                    console.log("After updation result : "+JSON.stringify(result));
                    this.setState({preConditionMSTList: result });

                    swal({ title: "Pre-condition master saved successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'fifth'}) }, 4000)
                }
            })
            .catch(err => {
                 swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, }); 
            });
        }
    }
    /* Protocol Precondition Changes End */

    /* Reduce Dosage Changes Start */
    getChemoMedAdverseEffect() {
        if(this.state.reduceDosageList === undefined || this.state.reduceDosageList.length == 0){
            return fetch(C.getUrl() + '/chemoMedicine/getChemoMedAdverseEffect/'+this.state.protocolId)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let resJson = JSON.parse(resObj.message);
                var arr = [];
                resJson.map(function (d) {
                    arr.push({ chemoMedicineDosageValue: d.chemoMedicineName, 
                        reduceDosageReportValues: d.reportValues,
                        chemoMedicineAdverseEffectXId: d.chemoMedicineAdverseEffectXId });
                });
                this.setState({ reduceDosageList: arr });
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }
    
    setReduceDosageHandler = (reduceDosageData) => { 
        var reduceDosageDataTemp= this.state.reduceDosageList;
        reduceDosageDataTemp.push(reduceDosageData);
        this.setState({ reduceDosageList: reduceDosageDataTemp }); 
        this.setState({ showReduceDosagePopup: false });
    }

    closeReduceDosagePopup = () => {
        this.setState({ showReduceDosagePopup: false });
    }

    showReduceDosagePopup = () => {
        this.setState({ showReduceDosagePopup: true });
        this.reduceDosageChild.current.getReduceDosageDetail(this.state.chemoMedicineList);
    }

    deleteReduceDosage = (chemoMedicineAdverseEffectXId, chemoMedicineDosageID, reduceDosageReportID) => {
        //console.log("chemoMedicineAdverseEffectXId : "+chemoMedicineAdverseEffectXId);
        if(chemoMedicineAdverseEffectXId === 0 || chemoMedicineAdverseEffectXId === ''){
            let arr = this.state.reduceDosageList;
            const requiredIndex = arr.findIndex(el => {
                if(el.chemoMedicineDosageID === chemoMedicineDosageID && el.reduceDosageReportID === reduceDosageReportID){
                    return el.chemoMedicineDosageID === chemoMedicineDosageID;
                }
            });
            //console.log("requiredIndex : "+requiredIndex);
            if(requiredIndex === -1){
                return false;
            };
    
            arr.splice(requiredIndex, 1);
            //console.log("tempArr : "+JSON.stringify(arr));
            this.setState({ reduceDosageList : arr });
        }else{
            swal({
                title: 'Are you sure?',
                text: "Once deleted you will not be able to recover this.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: "Yes",
                closeOnConfirm: false,
                buttons:true,
                buttons: ["No", "Yes"]
            }).then((isConfirm) => {
                if (isConfirm) {
                    return fetch(C.getUrl() + '/chemoMedicine/deleteChemoMedAdverseEffect/'+chemoMedicineAdverseEffectXId)
                    .then(res => res.json())
                    .then(res => {
                        let resObj = res;
                        console.log(JSON.stringify(resObj));
                        swal({ title: resObj.message, icon: "success", buttons: false, timer: 2000, });
                        
                        let arr = this.state.reduceDosageList;
                        const requiredIndex = arr.findIndex(el => {
                            return el.chemoMedicineAdverseEffectXId === chemoMedicineAdverseEffectXId;
                        });
                        //console.log("requiredIndex : "+requiredIndex);
                        if(requiredIndex === -1){
                            return false;
                        };
                
                        arr.splice(requiredIndex, 1);
                        //console.log("tempArr : "+JSON.stringify(arr));
                        this.setState({ reduceDosageList : arr });
                    })
                    .catch(err => {
                        console.log("Error : " + err);
                    });
                }
            });
        }
    }

    saveReduceDosage(event){
        var chemoMedicineAdverseEffectXDTOList = [];
        this.state.reduceDosageList.forEach(function (obj) {
            if(obj.chemoMedicineAdverseEffectXId == 0 || obj.chemoMedicineAdverseEffectXId == ''){
                let data = {
                    chemoMedicineAdverseEffectXId: obj.chemoMedicineAdverseEffectXId,
                    activeInd: 'Y',
                    createdDt: new Date(),
                    updatedDt: new Date(),
                    chemoMedicineDTO: {
                        chemoMedicineId: obj.chemoMedicineDosageID,
                        medicineMstDto: {
                            medicineName: obj.chemoMedicineDosageValue
                        }
                    },
                    createdByIdUser: {
                        userId: localStorage.getItem('userId')
                    }, 
                    updatedByIdUser: {
                        userId: localStorage.getItem('userId')
                    }, 
                    reportParameterMstDTO: {
                        reportParamId: obj.reduceDosageReportID,
                        reportParamName: obj.reduceDosageReportValues
                    }
                }
                chemoMedicineAdverseEffectXDTOList.push(data);
            }
        });
        if(chemoMedicineAdverseEffectXDTOList.length !== 0){
            return fetch(C.getUrl() + '/chemoMedicine/saveChemoMedicineAdverseEffect', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(chemoMedicineAdverseEffectXDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => {this.setState({ saveLoader: false })}, 3000)
                    let objmsg = JSON.parse(obj.message);

                    let tmpArr = this.state.reduceDosageList;
                    console.log("Before addition : "+JSON.stringify(tmpArr));

                    objmsg.map(function (d) {
                        tmpArr.push({ chemoMedicineDosageValue: d.chemoMedicineDTO.medicineMstDto.medicineName, 
                            reduceDosageReportValues: d.reportParameterMstDTO.reportParamName,
                            chemoMedicineAdverseEffectXId: d.chemoMedicineAdverseEffectXId });
                    });
                    console.log("After Addition : "+JSON.stringify(tmpArr));
                    let result = tmpArr.filter(
                    (thing, index, self) =>
                        index ===
                        self.findIndex((t) => t.chemoMedicineDosageValue === thing.chemoMedicineDosageValue
                        && t.reduceDosageReportValues === thing.reduceDosageReportValues
                        && t.chemoMedicineAdverseEffectXId !== 0)
                    );
                    console.log("After updation result : "+JSON.stringify(result));
                    this.setState({reduceDosageList: result });
                    swal({ title: "Reduce dosage saved successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'sixth'}) }, 4000)
                }
            })
            .catch(err => {
                 swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
        }
    }
    /* Reduce Dosage Changes End */

    /* Adverse Event Discontinue Changes Start */
    getAdverseEffectDiscontinueDetails() {
        if(this.state.advEffDiscontinueList === undefined || this.state.advEffDiscontinueList.length == 0){
            return fetch(C.getUrl() + '/adverseEffectMaster/getAdverseEffectDiscontinueDetails/'+this.state.protocolId)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let resJson = JSON.parse(resObj.message);
                var arr = [];
                resJson.map(function (d) {
                    arr.push({ chemoMedicineDosageValue: d.chemoMedicineName, 
                        reportValues: d.reportValues,
                        adverseEffectDiscontinueId: d.adverseEffectDiscontinueId });
                });
                this.setState({ advEffDiscontinueList: arr });
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }

    closeAdverseEffectDisPopup = () => {
        this.setState({ showAdverseEffectDisPopup: false });
    }

    showAdverseEffectDisPopup = () => {
        this.setState({ showAdverseEffectDisPopup: true }); 
        this.adverseEffectChild.current.getAdverseEffectDetail(this.state.chemoMedicineList);
    }

    setAdvEffDiscontinueHandler = (advEffDiscontinueData) => { 
        var advEffDiscontinueDataTemp= this.state.advEffDiscontinueList;
        advEffDiscontinueDataTemp.push(advEffDiscontinueData);
        this.setState({ advEffDiscontinueList: advEffDiscontinueDataTemp }); 
        this.setState({ showAdverseEffectDisPopup: false });
    }

    deleteAdverseEventDIS = (adverseEffectDiscontinueId, reportID) => {
        //console.log("adverseEffectDiscontinueId : "+adverseEffectDiscontinueId);
        if(adverseEffectDiscontinueId === 0 || adverseEffectDiscontinueId === ''){
            let arr = this.state.advEffDiscontinueList;
            const requiredIndex = arr.findIndex(el => {
                return el.reportID === reportID;
            });
            //console.log("requiredIndex : "+requiredIndex);
            if(requiredIndex === -1){
                return false;
            };
    
            arr.splice(requiredIndex, 1);
            //console.log("tempArr : "+JSON.stringify(arr));
            this.setState({ advEffDiscontinueList : arr });
        }else{
            swal({
                title: 'Are you sure?',
                text: "Once deleted you will not be able to recover this.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: "Yes",
                closeOnConfirm: false,
                buttons:true,
                buttons: ["No", "Yes"]
            }).then((isConfirm) => {
                if (isConfirm) {
                    return fetch(C.getUrl() + '/adverseEffectMaster/deleteAdverseEffectDiscontinue/'+adverseEffectDiscontinueId)
                    .then(res => res.json())
                    .then(res => {
                        let resObj = res;
                        console.log(JSON.stringify(resObj));
                        swal({ title: resObj.message, icon: "success", buttons: false, timer: 2000, });
                        
                        let arr = this.state.advEffDiscontinueList;
                        const requiredIndex = arr.findIndex(el => {
                            return el.adverseEffectDiscontinueId === adverseEffectDiscontinueId;
                        });
                        //console.log("requiredIndex : "+requiredIndex);
                        if(requiredIndex === -1){
                            return false;
                        };
                
                        arr.splice(requiredIndex, 1);
                        //console.log("tempArr : "+JSON.stringify(arr));
                        this.setState({ advEffDiscontinueList : arr });
                    })
                    .catch(err => {
                        console.log("Error : " + err);
                    });
                }
            });
        }
    }

    saveAdverseDiscontinue(event){
        var adverseEffectDiscontinueDTOList = [];
        this.state.advEffDiscontinueList.forEach(function (obj) {
            if(obj.adverseEffectDiscontinueId == 0 || obj.adverseEffectDiscontinueId == ''){
                let data = {
                    adverseEffectDiscontinueId: obj.adverseEffectDiscontinueId,
                    activeInd: 'Y',
                    chemoInstructions: obj.chemoInstructions,
                    createdDt: new Date(),
                    updatedDt: new Date(),
                    createdByIdUser: {
                        userId: localStorage.getItem('userId')
                    },
                    updatedByIdUser: {
                        userId: localStorage.getItem('userId')
                    }, 
                    chemoMedicineDTO: {
                        chemoMedicineId: obj.chemoMedicineDosageID,
                        medicineMstDto: {
                            medicineName: obj.chemoMedicineDosageValue
                        }
                    }, 
                    reportParameterMstDTO: {
                        reportParamId: obj.reportID,
                        reportParamName: obj.reportValues
                    },
                }
                adverseEffectDiscontinueDTOList.push(data);
            }
        });
        if(adverseEffectDiscontinueDTOList.length !== 0){
            return fetch(C.getUrl() + '/adverseEffectMaster/saveAdverseEffectDiscontinue', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(adverseEffectDiscontinueDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => {this.setState({ saveLoader: false })}, 3000)
                    let objmsg = JSON.parse(obj.message);

                    let tmpArr = this.state.advEffDiscontinueList;
                    console.log("Before addition : "+JSON.stringify(tmpArr));

                    objmsg.map(function (d) {
                        tmpArr.push({ chemoMedicineDosageValue: d.chemoMedicineDTO.medicineMstDto.medicineName, 
                            reportValues: d.reportParameterMstDTO.reportParamName,
                            adverseEffectDiscontinueId: d.adverseEffectDiscontinueId });
                    });
                    console.log("After Addition : "+JSON.stringify(tmpArr));
                    let result = tmpArr.filter(
                    (thing, index, self) =>
                        index ===
                        self.findIndex((t) => t.chemoMedicineDosageValue === thing.chemoMedicineDosageValue
                        && t.reportValues === thing.reportValues
                        && t.adverseEffectDiscontinueId !== 0)
                    );
                    console.log("After updation result : "+JSON.stringify(result));
                    this.setState({advEffDiscontinueList: result });
                    swal({ title: "Adverse events discontinue conditions saved successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'seventh'}) }, 4000)
                }
            })
            .catch(err => {
                 swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
        }
    }
    /* Adverse Event Discontinue Changes End */

    /* Adverse Event Termination Changes Start */

    getAdverseEffectTerminationDetails() {
        if(this.state.advEffTerminateList === undefined || this.state.advEffTerminateList.length == 0){
            return fetch(C.getUrl() + '/adverseEffectMaster/getAdverseEffectTerminationDetails/'+this.state.protocolId)
            .then(res => res.json())
            .then(res => {
                let resObj = res;
                let resJson = JSON.parse(resObj.message);
                var arr = [];
                resJson.map(function (d) {
                    arr.push({ message: d.message, 
                        reportName: d.reportValues,
                        chemoMedAdvEffectXId: d.chemoMedAdvEffectXId });
                });
                this.setState({ advEffTerminateList: arr });
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }

    setAdvEffTerminateHandler = (advEffTerminateData) => { 
        var advEffTerminateDataTemp= this.state.advEffTerminateList;
        advEffTerminateDataTemp.push(advEffTerminateData);
        this.setState({ advEffTerminateList: advEffTerminateDataTemp }); 
        this.setState({ showAdverseEffectTerPopup: false });
    }

    closeAdverseEffectTerPopup = () => {
        this.setState({ showAdverseEffectTerPopup: false });
    }

    showAdverseEffectTerPopup = () => {
        this.setState({ showAdverseEffectTerPopup: true });
    }

    deleteAdverseEffectTER = (chemoMedAdvEffectXId, reportID) => {
        //console.log("chemoMedAdvEffectXId : "+chemoMedAdvEffectXId);
        if(chemoMedAdvEffectXId === 0 || chemoMedAdvEffectXId === ''){
            let arr = this.state.advEffTerminateList;
            const requiredIndex = arr.findIndex(el => {
                return el.reportID === reportID;
            });
            //console.log("requiredIndex : "+requiredIndex);
            if(requiredIndex === -1){
                return false;
            };
    
            arr.splice(requiredIndex, 1);
            //console.log("tempArr : "+JSON.stringify(arr));
            this.setState({ advEffTerminateList : arr });
        }else{
            swal({
                title: 'Are you sure?',
                text: "Once deleted you will not be able to recover this.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: "Yes",
                closeOnConfirm: false,
                buttons:true,
                buttons: ["No", "Yes"]
            }).then((isConfirm) => {
                if (isConfirm) {
                    return fetch(C.getUrl() + '/adverseEffectMaster/deleteAdverseEffectTermination/'+chemoMedAdvEffectXId)
                    .then(res => res.json())
                    .then(res => {
                        let resObj = res;
                        console.log(JSON.stringify(resObj));
                        swal({ title: resObj.message, icon: "success", buttons: false, timer: 2000, });
                        
                        let arr = this.state.advEffTerminateList;
                        const requiredIndex = arr.findIndex(el => {
                            return el.chemoMedAdvEffectXId === chemoMedAdvEffectXId;
                        });
                        //console.log("requiredIndex : "+requiredIndex);
                        if(requiredIndex === -1){
                            return false;
                        };
                
                        arr.splice(requiredIndex, 1);
                        //console.log("tempArr : "+JSON.stringify(arr));
                        this.setState({ advEffTerminateList : arr });
                    })
                    .catch(err => {
                        console.log("Error : " + err);
                    });
                }
            });
        }
    }

    saveAdverseEffectTer(event){
        var adverseEffectTerminationDTOList = [];
        var tempProtocolId = this.state.protocolId;
        this.state.advEffTerminateList.forEach(function (obj) {
            if(obj.chemoMedAdvEffectXId == 0 || obj.chemoMedAdvEffectXId == ''){
                let data = {
                    chemoMedAdvEffectXId: obj.chemoMedAdvEffectXId,
                    activeInd: 'Y',
                    message: obj.message, 
                    reportParameterMstDTO: {
                        reportParamId: obj.reportID,
                        reportParamName: obj.reportName
                    }, 
                    protocolMstDTO: {
                        protocolId: tempProtocolId
                    }
                }
                adverseEffectTerminationDTOList.push(data);
            }
        });
        if(adverseEffectTerminationDTOList.length !== 0){
            return fetch(C.getUrl() + '/adverseEffectMaster/saveAdverseEffectTermination', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(adverseEffectTerminationDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => {this.setState({ saveLoader: false })}, 3000)
                    let objmsg = JSON.parse(obj.message);

                    let tmpArr = this.state.advEffTerminateList;
                    console.log("Before addition : "+JSON.stringify(tmpArr));

                    objmsg.map(function (d) {
                        tmpArr.push({ message: d.message, 
                            reportName: d.reportParameterMstDTO.reportParamName,
                            chemoMedAdvEffectXId: d.chemoMedAdvEffectXId });
                    });
                    console.log("After Addition : "+JSON.stringify(tmpArr));
                    let result = tmpArr.filter(
                    (thing, index, self) =>
                        index ===
                        self.findIndex((t) => t.message === thing.message
                        && t.reportName === thing.reportName
                        && t.chemoMedAdvEffectXId !== 0)
                    );
                    console.log("After updation result : "+JSON.stringify(result));
                    this.setState({advEffTerminateList: result });
                    swal({ title: "Adverse Event Termination conditions save successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'second'}) }, 4000)
                }
            })
            .catch(err => {
                    swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
        }
    }
    /* Adverse Event Termination Changes Start */

    cancelHandler = () => { this.setState({ redirectProtocolMaster: true }); }

    render() {
        if (this.state.redirectProtocolMaster === true) { return <Redirect to='ProtocolMaster' /> }
        
        const { chemoMedicineList, reduceDosageList, preConditionMSTList, protocolDosageList, 
            advEffDiscontinueList, advEffTerminateList, chemoDoseageList, scheduleMstArr } = this.state;

        const _this = this;
        
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        {<Top />}
                        <Container fluid>
                            <div className="app-content">
                                <section className="section">
                                    <div className="form-button">
                                        <h3 className="fs-18 mb-4 header_title text-black">
                                        <Button type="button" className="btn mr-2 btn-light" onClick={() => this.cancelHandler()}><FaArrowLeft className='fs-18' size='2.0rem' style={{verticalAlign: 'bottom'}}/> </Button>
                                        View Protocol</h3>
                                    </div>
                                    <div className="dropdown-divider pb-2"></div>
                                    {(() => {
                                        if (this.state.isProtocolEditable == 'N') {
                                            return (
                                                <>
                                                <Row>
                                                    <Col lg='12' id='contentMsg'>
                                                        <Alert variant="danger" style={{padding: '1.5rem'}} dismissible>
                                                            <b>This protocol has been used. Changes can done on "Protocol Details", "Reduce Dosage", "Adverse Event Discontinue" and "Adverse Event Termination" only.</b>
                                                        </Alert>
                                                    </Col>
                                                </Row>
                                                </>
                                            )
                                        }
                                    })()}
                                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                        <Row>
                                            <Col sm={4}>
                                                <Nav variant="pills" className="flex-column">
                                                    <Nav.Item><Nav.Link eventKey="first">Protocol Details</Nav.Link></Nav.Item>
                                                    <Nav.Item><Nav.Link eventKey="second" onClick={() => this.getChemoMedDetails()}>Chemo Medicine</Nav.Link></Nav.Item> 
                                                    <Nav.Item><Nav.Link eventKey="third" onClick={() => this.getProtocolDosageDetails()}>Protocol Dosage</Nav.Link></Nav.Item>
                                                    <Nav.Item><Nav.Link eventKey="fourth" onClick={() => this.getProtocolPreCondition()}>Pre-Condition Master</Nav.Link></Nav.Item>
                                                    <Nav.Item><Nav.Link eventKey="fifth" onClick={() => this.getChemoMedAdverseEffect()}>Reduce Dosage</Nav.Link></Nav.Item>
                                                    <Nav.Item><Nav.Link eventKey="sixth" onClick={() => this.getAdverseEffectDiscontinueDetails()}>Adverse Event Discontinue</Nav.Link></Nav.Item>
                                                    <Nav.Item><Nav.Link eventKey="seventh" onClick={() => this.getAdverseEffectTerminationDetails()}>Adverse Event Termination</Nav.Link></Nav.Item>
                                                </Nav>
                                            </Col>
                                            <Col sm={8}>
                                                <Tab.Content>
                                                    <Tab.Pane eventKey="first">
                                                        <div id="basicInfoTab">
                                                        <Row className="mb-3">
                                                            <Col lg='4'>
                                                                <Form.Group>
                                                                    <Form.Label>Protocol Title</Form.Label>
                                                                    <Form.Control type='text' placeholder='' name='protocolTitle' onChange={this.handleChange} value={this.state.protocolName} />
                                                                    <div className="invalid-feedback">{this.state.protocol["protocolTitle"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='4'>
                                                                <PrimarySitePicker
                                                                    idPrefix="view-protocol"
                                                                    options={this.state.primarySiteArr}
                                                                    selectedSites={this.state.primarySites}
                                                                    onChange={this.handlePrimarySitesChange}
                                                                    onLeadChange={this.handleLeadSiteChange}
                                                                />
                                                            </Col>
                                                            <Col lg='4'>
                                                                <Form.Group>
                                                                    <Form.Label>Protocol Type</Form.Label>
                                                                    <Form.Control as="select" id="" name='protocolType' value={this.state.protocolType} onChange={this.handleChange}>
                                                                        <option value="DEFAULT">- Select Type -</option>
                                                                        {
                                                                            protocolTypeArr.map((item, i) => {
                                                                                    return (
                                                                                        <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                                    );
                                                                                })
                                                                            }
                                                                    </Form.Control>
                                                                </Form.Group>
                                                                <div className="invalid-feedback">{this.state.protocol["schedule"]}</div>
                                                            </Col>
                                                            <Col lg='4'>
                                                                <Form.Group>
                                                                    <Form.Label>Schedule for doctor visit</Form.Label>
                                                                    <Form.Control as="select" id="" name='schedule' value={this.state.schedule} onChange={this.handleChange}>
                                                                        <option value="DEFAULT">- Select Schedule -</option>
                                                                        {
                                                                            scheduleMstArr.map((item, i) => {
                                                                                    return (
                                                                                        <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                                    );
                                                                                })
                                                                            }
                                                                    </Form.Control>
                                                                </Form.Group>
                                                                <div className="invalid-feedback">{this.state.protocol["schedule"]}</div>
                                                            </Col>
                                                            <Col lg='4'>
                                                                <Form.Group>
                                                                    <Form.Label>Antiemetic Risk</Form.Label>
                                                                    <Form.Control as="select" id="" name='antiemeticRisk' value={this.state.antiemeticRiskLvlId} onChange={this.handleChange}>
                                                                        {
                                                                            AntiemeticRiskList.map((item, i) => {
                                                                                return (
                                                                                    <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                                );
                                                                            })
                                                                        }
                                                                    </Form.Control>
                                                                    <div className="invalid-feedback">{this.state.protocol["antiemeticRisk"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='4'>
                                                                <Form.Group>
                                                                    <Form.Label>FN Risk(%)</Form.Label>
                                                                    <Form.Control as="select" id="" name='fnRisk' value={this.state.fnRisk} onChange={this.handleChange}>
                                                                        <option value="DEFAULT">- Select Risk Level -</option>
                                                                        {
                                                                            fnRiskArr.map((item, i) => {
                                                                                return (
                                                                                    <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                                );
                                                                            })
                                                                        }
                                                                    </Form.Control>
                                                                    <div className="invalid-feedback">{this.state.protocol["fnRisk"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='4'>
                                                                <Form.Group>
                                                                    <Form.Label>Schedule for dosage</Form.Label>
                                                                    <Form.Control as="select" id="" name='scheduleDosage' value={this.state.scheduleDosage} onChange={this.handleChange}>
                                                                        <option value="DEFAULT">- Select Schedule -</option>
                                                                        {
                                                                                scheduleMstArr.map((item, i) => {
                                                                                    return (
                                                                                        <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                                    );
                                                                                })
                                                                            }
                                                                    </Form.Control>
                                                                    <div className="invalid-feedback">{this.state.protocol["scheduleDosage"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='4'>
                                                                <Form.Group>
                                                                    <Form.Check
                                                                        type='checkbox'
                                                                        label='Multi-Day Cycle'
                                                                        name='multiDayCycle'
                                                                        checked={this.state.multiDayCycle}
                                                                        onChange={this.handleChange}
                                                                        className='mt-4 pt-2'
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            {this.state.multiDayCycle && (
                                                                <Col lg='4'>
                                                                    <Form.Group>
                                                                        <Form.Label>Treatment Days</Form.Label>
                                                                        <Form.Control type='text' placeholder='e.g. 1-5 or 1,7,15' name='treatmentDays' value={this.state.treatmentDays} onChange={this.handleChange} />
                                                                        <div className="invalid-feedback">{this.state.protocol["treatmentDays"]}</div>
                                                                    </Form.Group>
                                                                </Col>
                                                            )}
                                                            <Col lg='12'>
                                                                <Form.Group>
                                                                    <Form.Label>Chemotherapy Dosage Method</Form.Label>
                                                                    <Form.Control as='textarea' placeholder='' maxLength='65535' rows={2} name='chemoDoseage' onChange={this.handleChange} value={this.state.chemoDoseage}/>
                                                                    <div className="invalid-feedback">{this.state.protocol["chemoDoseage"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg='6'>
                                                                <Form.Group>
                                                                    <Form.Label>Special Instruction to Nurse</Form.Label>
                                                                    <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='instructNurse' onChange={this.handleChange} value={this.state.instructNurse}/>
                                                                    <div className="invalid-feedback">{this.state.protocol["instructNurse"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='6'>
                                                                <Form.Group>
                                                                    <Form.Label>Special Instruction to Patients</Form.Label>
                                                                    <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='instructPatient' onChange={this.handleChange} value={this.state.instructPatient}/>
                                                                    <div className="invalid-feedback">{this.state.protocol["instructPatient"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='6'>
                                                                <Form.Group>
                                                                    <Form.Label>Next Visit Instructions</Form.Label>
                                                                    <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='nextVisit' onChange={this.handleChange} value={this.state.nextVisit}/>
                                                                    <div className="invalid-feedback">{this.state.protocol["nextVisit"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='6'>
                                                                <Form.Group>
                                                                    <Form.Label>Drug Interactions</Form.Label>
                                                                    <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='drugInteractions' onChange={this.handleChange} value={this.state.drugInteractions}/>
                                                                    <div className="invalid-feedback">{this.state.protocol["drugInteractions"]}</div>
                                                                </Form.Group>
                                                            </Col> 
                                                            <Col lg='6'>
                                                                <Form.Group>
                                                                    <Form.Label>Stockist Instructions</Form.Label>
                                                                    <Form.Control as='textarea' className="custom-height"placeholder='' rows={2} name='instructStockist' onChange={this.handleChange} value={this.state.instructStockist}/>
                                                                    <div className="invalid-feedback">{this.state.protocol["instructStockist"]}</div>
                                                                </Form.Group>
                                                            </Col> 
                                                            <Col lg='6'>
                                                                <Form.Group>
                                                                    <Form.Label>Adverse Events</Form.Label>
                                                                    <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='adverseEvent' onChange={this.handleChange} value={this.state.adverseEvent}/>
                                                                    <div className="invalid-feedback">{this.state.protocol["adverseEvent"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg='6'>
                                                                <Form.Group>
                                                                    <Form.Label>Risk of Death</Form.Label>
                                                                    <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='riskDeath' onChange={this.handleChange} value={this.state.riskDeath}/>
                                                                    <div className="invalid-feedback">{this.state.protocol["riskDeath"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='6'>
                                                                <Form.Group>
                                                                    <Form.Label>Reference</Form.Label>
                                                                    <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='reference' onChange={this.handleChange} value={this.state.reference}/>
                                                                    <div className="invalid-feedback">{this.state.protocol["reference"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='12'>
                                                                <div className="form-button text-center">
                                                                    <Button type="button" className="btn pt-2 pb-2 btn-secondary"
                                                                        onClick={this.saveProtocol.bind(this)}
                                                                        disabled={this.state.isHospitalAdmin && (this.state.protocolInstituteId === null || !this.state.userInstituteIds.includes(this.state.protocolInstituteId))}>
                                                                        {this.state.saveLoader && (
                                                                            <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                        )}
                                                                        {!this.state.saveLoader && (
                                                                            <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                        )}
                                                                        Save
                                                                    </Button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="second">
                                                        <div id="chemomedicineTab">
                                                        {(() => {
                                                            if (this.state.isProtocolEditable == 'Y') {
                                                                return (
                                                                    <>
                                                                    <Row>
                                                                        <Col lg='12'>
                                                                            <Button variant="secondary" className="btn pull-right mb-1" onClick={() => this.setState({ showChemoMedicinePopup: true })}>New Chemo Medicine</Button>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col lg='12'>
                                                                            <table className="table table-striped table-hover" role="grid">
                                                                                <thead className="thead-light">
                                                                                    <tr role="row">
                                                                                        <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th>
                                                                                        <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Medicine</th>
                                                                                        <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Dosage Method</th>
                                                                                        <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    { this.state.chemoMedicineList.map(function (d, idx) {
                                                                                        return (
                                                                                            <tr key={idx} role="row" className="odd">
                                                                                                <td>{idx + 1}</td>
                                                                                                <td>{d.chemoMedicineName}</td>
                                                                                                <td>{d.chemoInstructions}</td>
                                                                                                <td>
                                                                                                    <a className='text-primary font-w500' onClick={() => _this.deleteChemo(d.chemoMedicineId, d.chemoMedicineName)}>
                                                                                                        <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                                    </a>
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    })}
                                                                                </tbody>
                                                                            </table>
                                                                        </Col> 
                                                                        <Col lg='12'>
                                                                            <div className="form-button text-center">
                                                                                <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveChemo.bind(this)}>
                                                                                    {this.state.saveLoader && (
                                                                                        <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                                    )}
                                                                                    {!this.state.saveLoader && (
                                                                                        <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                                    )}
                                                                                    Save
                                                                                </Button>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    </>
                                                                )
                                                            }else{
                                                                return (
                                                                    <>
                                                                    <Row>
                                                                        <Col lg='12'>
                                                                            <table className="table table-striped table-hover" role="grid">
                                                                                <thead className="thead-light">
                                                                                    <tr role="row">
                                                                                        <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th>
                                                                                        <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Medicine</th>
                                                                                        <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Dosage Method</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    { this.state.chemoMedicineList.map(function (d, idx) {
                                                                                        return (
                                                                                            <tr key={idx} role="row" className="odd">
                                                                                                <td>{idx + 1}</td>
                                                                                                <td>{d.chemoMedicineName}</td>
                                                                                                <td>{d.chemoInstructions}</td>
                                                                                            </tr>
                                                                                        );
                                                                                        })}
                                                                                </tbody>
                                                                            </table>
                                                                        </Col>
                                                                    </Row>
                                                                    </>
                                                                )
                                                            }
                                                        })()}
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="third">
                                                        <div id="protocolDosageTab">
                                                            {(() => {
                                                                if (this.state.isProtocolEditable == 'Y') {
                                                                    return (
                                                                        <>
                                                                        <Row>
                                                                            <Col lg='12'>
                                                                                <Button variant="secondary" className="btn pull-right mb-1" onClick={this.showProtocolDosagePopup.bind(this)}>Add Chemo Dosage</Button>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col lg='12'>
                                                                                <table className="table table-striped table-hover" role="grid">
                                                                                    <thead className="thead-light">
                                                                                        <tr role="row">
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Chemo medicine</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Dosage</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Dosage Qty</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Unit</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        { this.state.protocolDosageList.map(function (d, idx) {
                                                                                            return (
                                                                                                <tr key={idx} role="row" className="odd">
                                                                                                    <td>{idx + 1}</td>
                                                                                                    <td>{d.chemoMedicineDosageValue}</td>
                                                                                                    <td>{d.dosageValues}</td>
                                                                                                    <td>{d.dosageQtys}</td>
                                                                                                    <td>{d.dosageUnitValues}</td>
                                                                                                    <td>
                                                                                                        <a className='text-primary font-w500' onClick={() => _this.deleteProtocolDosage(d.chemoMedicineDId, d.chemoMedicineDosageID, d.dosageValues, d.dosageQtys)}>
                                                                                                            <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                                        </a>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            );
                                                                                        })}
                                                                                    </tbody>
                                                                                </table>
                                                                            </Col>
                                                                            <Col lg='12'>
                                                                                <div className="form-button text-center">
                                                                                    <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveProtocolDosage.bind(this)}>
                                                                                        {this.state.saveLoader && (
                                                                                            <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                                        )}
                                                                                        {!this.state.saveLoader && (
                                                                                            <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                                        )}
                                                                                        Save
                                                                                    </Button>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                        </>
                                                                    )
                                                                }else{
                                                                    return (
                                                                        <>
                                                                        <Row>
                                                                            <Col lg='12'>
                                                                                <table className="table table-striped table-hover" role="grid">
                                                                                    <thead className="thead-light">
                                                                                        <tr role="row">
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Chemo medicine</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Dosage</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Dosage Qty</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Unit</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        { this.state.protocolDosageList.map(function (d, idx) {
                                                                                            return (
                                                                                                <tr key={idx} role="row" className="odd">
                                                                                                    <td>{idx + 1}</td>
                                                                                                    <td>{d.chemoMedicineDosageValue}</td>
                                                                                                    <td>{d.dosageValues}</td>
                                                                                                    <td>{d.dosageQtys}</td>
                                                                                                    <td>{d.dosageUnitValues}</td> 
                                                                                                </tr>
                                                                                            );
                                                                                            })}
                                                                                    </tbody>
                                                                                </table>
                                                                            </Col>
                                                                        </Row> 
                                                                        </>
                                                                    )
                                                                }
                                                            })()}
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="fourth">
                                                        <div id="preconditionMST">
                                                            {(() => {
                                                                if (this.state.isProtocolEditable == 'Y') {
                                                                    return (
                                                                        <>
                                                                        <Row>
                                                                            <Col lg='12'>
                                                                                <Button variant="secondary" className="btn pull-right mb-1" onClick={this.showPreConditionMSTPopup.bind(this)}>Add Pre-Condition</Button>
                                                                            </Col>
                                                                        </Row> 
                                                                        <Row>
                                                                            <Col lg='12'>
                                                                                <table className="table table-striped table-hover" role="grid">
                                                                                    <thead className="thead-light">
                                                                                        <tr role="row">
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Report Parameter</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Comparision</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Value</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        { this.state.preConditionMSTList.map(function (d, idx) {
                                                                                            return (
                                                                                                <tr key={idx} role="row" className="odd">
                                                                                                    <td>{idx + 1}</td>
                                                                                                    <td>{d.reportParamsNames}</td>
                                                                                                    <td>{d.preConditionListsNames}</td>
                                                                                                    <td>{d.preConditionValues}</td>
                                                                                                    <td>
                                                                                                        <a className='text-primary font-w500' onClick={() => _this.deletePrecondition(d.protocolpreconditionsId, d.reportParamsID, d.preConditionValues)}>
                                                                                                            <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                                        </a>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            );
                                                                                        })}
                                                                                    </tbody>
                                                                                </table>
                                                                            </Col>
                                                                            <Col lg='12'>
                                                                                <div className="form-button text-center">
                                                                                    <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.savePreConditionMST.bind(this)}>
                                                                                        {this.state.saveLoader && (
                                                                                            <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                                        )}
                                                                                        {!this.state.saveLoader && (
                                                                                            <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                                        )}
                                                                                        Save
                                                                                    </Button>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                        </>
                                                                    )
                                                                }else{
                                                                    return (
                                                                        <>
                                                                        <Row>
                                                                            <Col lg='12'>
                                                                                <table className="table table-striped table-hover" role="grid">
                                                                                    <thead className="thead-light">
                                                                                        <tr role="row">
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Report Parameter</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Comparision</th>
                                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Value</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        { this.state.preConditionMSTList.map(function (d, idx) {
                                                                                            return (
                                                                                                <tr key={idx} role="row" className="odd">
                                                                                                    <td>{idx + 1}</td>
                                                                                                    <td>{d.reportParamsNames}</td>
                                                                                                    <td>{d.preConditionListsNames}</td>
                                                                                                    <td>{d.preConditionValues}</td> 
                                                                                                </tr>
                                                                                            );
                                                                                            })}
                                                                                    </tbody>
                                                                                </table>
                                                                             </Col>
                                                                        </Row>
                                                                        </>
                                                                    )
                                                                }
                                                            })()}
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="fifth">
                                                        <div id="reduceDosageTab">
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <Button variant="secondary" className="btn pull-right mb-1" onClick={this.showReduceDosagePopup.bind(this)}>Add Dosage Reduction</Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <table className="table table-striped table-hover" role="grid">
                                                                        <thead className="thead-light">
                                                                            <tr role="row">
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Adverse Event</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Chemo medicine</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            { this.state.reduceDosageList.map(function (d, idx) {
                                                                                return (
                                                                                    <tr key={idx} role="row" className="odd">
                                                                                        <td>{idx + 1}</td>
                                                                                        <td>{d.reduceDosageReportValues}</td>
                                                                                        <td>{d.chemoMedicineDosageValue}</td>
                                                                                        <td>
                                                                                            <a className='text-primary font-w500' onClick={() => _this.deleteReduceDosage(d.chemoMedicineAdverseEffectXId, d.chemoMedicineDosageID, d.reduceDosageReportID)}>
                                                                                                <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                                })}
                                                                        </tbody>
                                                                    </table>
                                                                    </Col>
                                                                    <Col lg='12'>
                                                                    <div className="form-button text-center">
                                                                        <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveReduceDosage.bind(this)}>
                                                                            {this.state.saveLoader && (
                                                                                <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                            )}
                                                                            {!this.state.saveLoader && (
                                                                                <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                            )}
                                                                            Save
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="sixth">
                                                        <div id="adverseEffectDisTab">
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <Button variant="secondary" className="btn pull-right mb-1" onClick={this.showAdverseEffectDisPopup.bind(this)}>New Adverse Event</Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <table className="table table-striped table-hover" role="grid">
                                                                        <thead className="thead-light">
                                                                            <tr role="row">
                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Adverse Event</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Chemo medicine</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                            <tbody>
                                                                            { this.state.advEffDiscontinueList.map(function (d, idx) {
                                                                                return (
                                                                                    <tr key={idx} role="row" className="odd">
                                                                                        <td>{idx + 1}</td>
                                                                                        <td>{d.reportValues}</td>
                                                                                        <td>{d.chemoMedicineDosageValue}</td>
                                                                                        <td>
                                                                                            <a className='text-primary font-w500' onClick={() => _this.deleteAdverseEventDIS(d.adverseEffectDiscontinueId, d.reportID)}>
                                                                                                <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody> 
                                                                    </table>
                                                                    </Col>
                                                                    <Col lg='12'>
                                                                    <div className="form-button text-center">
                                                                        <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveAdverseDiscontinue.bind(this)}>
                                                                            {this.state.saveLoader && (
                                                                                <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                            )}
                                                                            {!this.state.saveLoader && (
                                                                                <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                            )}
                                                                            Save
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="seventh">
                                                        <div id="adverseEffectTerTab">
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <Button variant="secondary" className="btn pull-right mb-1" onClick={() => this.setState({ showAdverseEffectTerPopup: true })}>New Adverse Event</Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <table className="table table-striped table-hover" role="grid">
                                                                        <thead className="thead-light">
                                                                            <tr role="row">
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Adverse Event</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">message</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            { this.state.advEffTerminateList.map(function (d, idx) {
                                                                                return (
                                                                                    <tr key={idx} role="row" className="odd">
                                                                                        <td>{idx + 1}</td>
                                                                                        <td>{d.reportName}</td>
                                                                                        <td>{d.message}</td>
                                                                                        <td>
                                                                                            <a className='text-primary font-w500' onClick={() => _this.deleteAdverseEffectTER(d.reportID)}>
                                                                                                <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                                })}
                                                                        </tbody>
                                                                    </table>
                                                                    </Col>
                                                                    <Col lg='12'>
                                                                    <div className="form-button text-center">
                                                                        <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveAdverseEffectTer.bind(this)}>
                                                                            {this.state.saveLoader && (
                                                                                <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                            )}
                                                                            {!this.state.saveLoader && (
                                                                                <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                            )}
                                                                            Save
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            </Col>
                                        </Row>
                                    </Tab.Container>
                                </section>
                            </div>
                        </Container>
                        <ChemoMedicinePopup
                            saveChemoMedicine={(data) => this.setChemoMedicineHandler(data)}
                            showChemoMedicinePopup={this.state.showChemoMedicinePopup} closeModal={() => this.closeChemoMedicinePopup()}
                        />
                        <ProtocolDosagePopup 
                            ref={this.protocolDosageChild}
                            saveProtocolDosageTable={(data) => this.setProtocolDosageHandler(data)}
                            showProtocolDosagePopup={this.state.showProtocolDosagePopup} closeModal={() => this.closeProtocolDosagePopup()}
                        />
                        <PreConditionMSTPopup 
                            savePreConditionMST={(data) => this.setPreConditionMSTHandler(data)}
                            showPreConditionMSTPopup={this.state.showPreConditionMSTPopup} closeModal={() => this.closePreConditionMSTPopup()}
                        />
                        <ReduceDosagePopup
                            ref={this.reduceDosageChild}
                            saveReduceDosageTable={(data) => this.setReduceDosageHandler(data)}
                            showReduceDosagePopup={this.state.showReduceDosagePopup} closeModal={() => this.closeReduceDosagePopup()}
                        />
                        <AdverseEffectDisPopup
                            ref={this.adverseEffectChild}
                            saveAdvEffDiscontinue={(data) => this.setAdvEffDiscontinueHandler(data)}
                            showAdverseEffectDisPopup={this.state.showAdverseEffectDisPopup} closeModal={() => this.closeAdverseEffectDisPopup()}
                        />
                        <AdverseEffectTerPopup 
                            saveAdvEffTerminate={(data) => this.setAdvEffTerminateHandler(data)}
                            showAdverseEffectTerPopup={this.state.showAdverseEffectTerPopup}  closeModal={() => this.closeAdverseEffectTerPopup()}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
